

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVisitLocations } from "../redux/actions/VisitLocationActions"; // ✅ Correct path
import theme from "../components/shared/theme";
import { thStyle, tdStyle } from "../components/shared/themeStyles";

const VisitLocation = () => {
  const dispatch = useDispatch();
  const { locations, loading, error } = useSelector((state) => state.VisitLocation);

  useEffect(() => {
    dispatch(fetchVisitLocations());
  }, [dispatch]);

  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        padding: theme.spacing.md,
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: theme.font.size["2xl"],
          fontWeight: theme.font.weight.bold,
          marginBottom: theme.spacing.md,
        }}
      >
        Visit Location List
      </h1>

      {loading ? (
        <p style={{ fontSize: theme.font.size.base }}>Loading locations...</p>
      ) : error ? (
        <div
          style={{
            backgroundColor: theme.colors.dangerLight,
            border: `1px solid ${theme.colors.danger}`,
            color: theme.colors.dangerText,
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
          }}
        >
          Error: {error}
        </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[600px] w-full text-sm text-left">
            <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Location Name</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {locations.map((location, index) => (
                <tr key={location.id || index} className="hover:bg-gray-50">
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{location.location_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VisitLocation;
